import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import ReminderLogs from '../../components/Reminders/ReminderLogs';
import {
  PERMISSION_REMINDERS,
  PERMISSION_REMINDERS_OWNED_BY_USER,
} from '../../Services/PermissionsService';
import { requirePermissions } from '../../router/RouteGuardsService';

// Optional pre-filter: opened from the reminders list row actions with ?reminder-id=<id>
const reminderLogsSearchSchema = z.object({
  'reminder-id': z.coerce.number().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/reminders/logs')({
  validateSearch: reminderLogsSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermissions(
      [PERMISSION_REMINDERS, PERMISSION_REMINDERS_OWNED_BY_USER],
      ['read'],
      '/unauthorized',
      context
    );
    return {
      ...context,
      documentTitle: { main: 'tab.reminders/logs', suffix: 'menu.reminders' },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ReminderLogsRoute,
});

function ReminderLogsRoute() {
  return <ReminderLogs />;
}
